import React, {useContext, useEffect, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as DOWN } from "../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../assets/icons/filter-up.svg";
import { FormTextInput } from "../Components/FormTextInput";
import { Check } from "react-feather";
import SingleLanguageFilter from "../Screens/Account/OrdersComponents/SingleLanguageFilter";
import { firestore, getFullHttpUrl } from "../firebase.config";
import axios from "axios";
import { NotificationContext } from "../Context/NotificationContext";
import { EAST1, EAST4 } from "../utility/enums";

const ResetPasswordBackend = ({ onClose }) => {
  const emailRegex = new RegExp(
    "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
  );

  const {showNotification} = useContext(NotificationContext)

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [btnText,setBtnText] = useState("Update Password");

  const updatePassword = async() => {
    setBtnText("Updating...");

    try{

        await axios.post(getFullHttpUrl("resetUserPassword", EAST4), {email: email.toLowerCase(),password}).then(() => {
            setBtnText("Update Password");
            showNotification("Success", "User password updated successfully!", "success");
            onClose();
        })
    }catch(e){
        console.log(e)
        showNotification("Error", "Error reseting user password!", "error");
        setBtnText("Update Password");
    }

  }
 
  return (
    <div className="newPopUpModalWrap">
      <div className="employeeUpdateModalContainer">
        <h2 className="newPopUpModalTitle">
         Change User Password
        </h2>
       
        <div className="quoteDetailsInputsContainer">
          <FormTextInput
            placeholder="Email"
            value={email}
            onChange={setEmail}
            focus={true}
          />
          <FormTextInput
            placeholder="New Password"
            value={password}
            onChange={setPassword}
          />
        </div>


        <div className="quoteDetailsInputsContainer">
          <NewButton text="Cancel" onClick={onClose} whiteBtn={true} back={true} icon={false}/>
          <NewButton
            text={btnText}
            onClick={updatePassword}
            disabled={email === "" || password === "" || btnText === "Updating..." || !emailRegex.test(email) || password.length < 6}
          />
        </div>
        <Close className="newPopUpModalCloseIcon" onClick={onClose} />
      </div>
    </div>
  );
};

export default ResetPasswordBackend;
